import script from "./application-view.vue?vue&type=script&setup=true&lang=js"
export * from "./application-view.vue?vue&type=script&setup=true&lang=js"

import "./application-view.vue?vue&type=style&index=0&id=5cb223df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb223df"]])

export default __exports__